let productData = window.__product__;
let $buyNow = $(".enroll-buy-now");

//立即购买
$buyNow.on("click", function() {
    let productPrice = productData.variants[0].price;
    let variantId = productData.variants[0].id;
    let sku = productData.variants[0].sku;
    let title = productData.title;
    let count = 1;
    buyNow(variantId, count, productPrice, title, sku);
});

if(getParams('token')){
    const token = getParams('token')
    document.cookie = `zus_token=${token};path=/;domain=.nonda.co`
}
